export enum SecurityFeatureActionType {
  REQUEST_SECURITY_FEATURE = 'REQUEST_SECURITY_FEATURE',
  RECEIVE_SECURITY_FEATURE = 'RECEIVE_SECURITY_FEATURE',
  RECEIVE_SECURITY_FEATURE_ERROR = 'RECEIVE_SECURITY_FEATURE_ERROR',
  RESET_SECURITY_FEATURE = 'RESET_SECURITY_FEATURE',
}

export type SecurityFeatureAction = IReceiveSecurityFeatureAction | IRequestSecurityFeatureAction | IReceiveSecurityFeatureErrorAction | IResetSecurityFeatureAction;

export interface IRequestSecurityFeatureAction {
  type: SecurityFeatureActionType.REQUEST_SECURITY_FEATURE;
  featureName: any;
}

export interface IReceiveSecurityFeatureAction {
  type: SecurityFeatureActionType.RECEIVE_SECURITY_FEATURE;
  data: any;
}

export interface IReceiveSecurityFeatureErrorAction {
  type: SecurityFeatureActionType.RECEIVE_SECURITY_FEATURE_ERROR;
  errorMessage: string;
}

export interface IResetSecurityFeatureAction {
  type: SecurityFeatureActionType.RESET_SECURITY_FEATURE;
}

// Feature Flag List - GetFeatureNamesAsync
export enum FeatureFlagListActionType {
  REQUEST_FEATURE_FLAG_LIST = 'REQUEST_FEATURE_FLAG_LIST',
  RECEIVE_FEATURE_FLAG_LIST = 'RECEIVE_FEATURE_FLAG_LIST',
  RECEIVE_FEATURE_FLAG_LIST_ERROR = 'RECEIVE_FEATURE_FLAG_LIST_ERROR',
  RESET_FEATURE_FLAG_LIST = 'RESET_FEATURE_FLAG_LIST',
}

export type FeatureFlagListAction = IReceiveFeatureFlagListAction | IRequestFeatureFlagListAction | IReceiveFeatureFlagListErrorAction | IResetFeatureFlagListAction;

export interface IRequestFeatureFlagListAction {
  type: FeatureFlagListActionType.REQUEST_FEATURE_FLAG_LIST;
}

export interface IReceiveFeatureFlagListAction {
  type: FeatureFlagListActionType.RECEIVE_FEATURE_FLAG_LIST;
  data: any;
}

export interface IReceiveFeatureFlagListErrorAction {
  type: FeatureFlagListActionType.RECEIVE_FEATURE_FLAG_LIST_ERROR;
  errorMessage: string;
}

export interface IResetFeatureFlagListAction {
  type: FeatureFlagListActionType.RESET_FEATURE_FLAG_LIST;
}